import React from 'react';
import { SUPERSIM_SPONSORED_NEWS_LOGO_PATH } from '../../components/news/helpers/superSimSponsoredNews';

const SuperSimSponsoredArticleNotice = () => (
    <aside className="superSimSponsoredArticleNotice" aria-label="SuperSim">
        <img
            src={SUPERSIM_SPONSORED_NEWS_LOGO_PATH}
            alt="SuperSim"
            className="superSimSponsoredArticleNotice__logo"
            loading="eager"
            decoding="async"
        />
    </aside>
);

export default SuperSimSponsoredArticleNotice;
